module.exports = __webpack_public_path__ + "static/media/endMainImg.0757bea6.png";